import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TokenStorageService } from 'src/app/core/auth/token-storage.service';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { getdateformatService } from 'src/app/core/services/get-date-format.service';
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';
import { ContactUsDialogComponent } from 'src/app/shared/components/dialog-box';
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';



@Component({
  selector: 'app-subscription-add-new-customer',
  templateUrl: './subscription-add-new-customer.component.html',
  styleUrls: ['./subscription-add-new-customer.component.css']
})
export class SubscriptionAddNewCustomerComponent implements OnInit {

  constructor(private apiCall: ApiCallService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private tokenStorage : TokenStorageService,
    private dialogRef: MatDialogRef<SubscriptionAddNewCustomerComponent>,
    private _i18nDynamicTranslate: TranslateDynamicText,
    private date_format: getdateformatService,
    private snackBar: SnackbarCollection) { }
  name = "";
  lastname = "";
  email = "";
  number = "";
  unamePattern = "^[A-Za-z0-9_ ]{3,15}$";
  emailPattern = "^[a-zA-Z0-9_._%+-]+@[a-zA-Z0-9_.-]+\\.[a-zA-Z]{2,5}$";
  errorName = "";
  dateOfBirth;
  anniversary;
  errorLastName = ""
  errorMail = "";
  phoneNumberErrorText = "";
  apiloading = false;
  countryCode = "91";
  countryCodeData = [];
  mobilenumberPattern = /^\d{10}$/;
  startDateMinValue;
  genderList = ['Male','Female','Others'];
  gender = "";
  country;
  telInputObj;


  ngOnInit(): void {
    let currentDate = new Date();
    this.startDateMinValue = new Date(
      currentDate.toLocaleString("en-US", {
        timeZone: this.tokenStorage.getMerchantTimeZone(),
      })
    );
    this.country = sessionStorage.getItem("serviceCountry")
    this.getCountryCode();
  }

  keypress() {
    this.errorName = "";
    this.errorLastName="";
    this.errorMail = "";
  }

  getCountryCode() {
    this.apiCall.getCountryCode().subscribe((response) => {
      this.countryCodeData = response['body'];

    })
  }

  changeCountry(code){
    this.countryCode = code;
  }


  submit() {
    this.dialogRef.close(false)
  }

  add(){
      if(this.email.length>0 && this.name.length>0){
        if(!this.checkValidation()){
          return;
        }
        if(this.phoneNumberErrorText.length>0){
            return;
        }
        else{
          this.apiloading=true;  
          let data = {
            "merchantId": this.tokenStorage.getMerchantId(),
            "firstname": this.name,
            "email": this.email,
            "isLoyaltyConsentGiven": true,
            "emailOtpVerificationRequired": false,
            "mobileOtpVerificationRequired": false
          };

          if (this.lastname && this.lastname.length > 0) {
            data["lastname"] = this.lastname;
          }
          
          if (this.number && this.number.length > 0) {
            data["phone"] = this.countryCode + this.number;
          }
          
          if (this.dateOfBirth) {
            data["dateOfBirth"] = this.datePipe.transform(this.dateOfBirth, "yyyy-MM-dd");
          }
          
          if (this.anniversary) {
            data["anniversaryDate"] = this.datePipe.transform(this.anniversary, "yyyy-MM-dd");
          }
          
          if (this.gender && this.gender.length > 0) {
            data["gender"] = this.gender;
          }
          this.apiCall.subscriptionCreateCustomer(data).subscribe((response)=>{
            if(response){
              this.dialogRef.close(true);
            }   
          },(error)=>
          {  
              this.apiloading = false;
              this.snackBar.openSnackBar("Something Went Wrong", 2000);
                 
          }
        );
          this.apiloading=false
        }
      }
      else{
        this.apiloading=false;  
        if(this.email.length<1){
          this.errorMail= this._i18nDynamicTranslate.transform("Email cannot be empty", ['POS_PAGE'])
        }
        if(this.name.length<1){
          this.errorName= this._i18nDynamicTranslate.transform("First Name cannot be empty", ['POS_PAGE'])
        }
      
      }
    }

    checkValidation(){
      if(this.checkIfValid()){
        if(this.email.match(this.emailPattern.trim())==null){
          this.errorMail=this._i18nDynamicTranslate.transform("Please Enter Valid Email Address", ['POS_PAGE']);
        }
        if(this.name.length>15){
          this.errorName=this._i18nDynamicTranslate.transform("This field cannot have more than 15 characters", ['POS_PAGE'])
        }
        else if(this.name.match(this.unamePattern)==null){
          this.errorName=this._i18nDynamicTranslate.transform("Please Enter Valid First Name", ['POS_PAGE'])
        }
        return false;
      }
      return true;
    }

    checkIfValid(){
      if(this.email.match(this.emailPattern.trim())==null || (this.name.match(this.unamePattern)==null)){
        return true;
      }
      else{
        return false;
      }
    }

    getDateFormat(type?){
      return this.date_format.getDateFormat(type);
    }

    telInputObject(obj: any) {
      this.telInputObj = obj;
    }

    onInputChange() {
      if (this.telInputObj) {
        const inputValue = this.telInputObj.getNumber(); 
        if (!inputValue || inputValue.trim() === '') {
          this.phoneNumberErrorText = '';
          this.number = ''; 
          return;
        }
    
        const isValid = this.telInputObj.isValidNumber();
        if (isValid) {
          this.phoneNumberErrorText = '';
          this.number = this.telInputObj.getNumber();
          console.log('Valid number:', this.number);
        } else {
          this.phoneNumberErrorText = 'Please enter a valid phone number.';
          console.log('Invalid number');
        }
      }
    }
    
    getNumber(obj: any) {
      this.number = obj;
    }
    
    onCountryChange(obj: any) {
    }




}
  

